var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoviderSearchBackground = function SvgPoviderSearchBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1365,
    height: 1127,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M226.085-237.735C-91.192-255.153-94.562 78.355-56.587 247.287 100.829 680.81 376.049 421.403 363.037 139.43s390.294 74.882 543.106-241.719c177.187-367.11-283.462-113.673-680.058-135.446Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M230.03-223.174C-86.446-251.654-101.453 81.534-69.397 251.688c142.19 438.752 426.296 189.108 423.132-93.147s387.444 88.457 551.212-222.617C1094.84-424.78 625.624-187.573 230.03-223.174Z",
    opacity: 0.959
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M233.463-208.484C-81.826-247.992-108.451 84.469-82.353 255.638c126.791 443.447 419.436 203.871 426.125-78.323 6.688-282.194 384.12 101.925 558.645-203.244C1104.78-379.785 627.574-159.1 233.463-208.484Z",
    opacity: 0.917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M236.382-193.684C-77.336-244.171-115.548 87.158-95.44 259.134 15.798 706.736 316.627 477.519 333.16 195.73c16.533-281.789 380.33 115.268 565.398-183.624 214.593-346.578-270.027-142.681-662.175-205.79Z",
    opacity: 0.876
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M238.783-178.791C-72.982-240.196-122.735 89.599-108.64 262.171c95.549 451.211 404.194 232.633 430.551-48.407s376.074 128.471 571.461-163.78c226.558-338.878-264.883-152.018-654.589-228.775Z",
    opacity: 0.835
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M240.662-163.823c-309.432-72.248-370.664 255.609-362.6 428.568 79.743 454.272 395.828 246.598 431.977-33.352s371.362 141.518 576.83-143.736c238.251-330.765-259.417-161.17-646.207-251.48Z",
    opacity: 0.794
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M242.018-148.798C-64.704-231.802-137.341 93.719-135.319 266.854c63.842 456.778 386.982 260.261 432.879-18.256S663.757 402.991 879.054 125.08C1128.7-197.168 625.421-45.044 242.018-148.798Z",
    opacity: 0.752
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M242.849-133.736c-303.639-93.657-387.592 229.13-391.613 402.23 47.861 458.728 377.663 273.609 433.252-3.137s360.586 167.078 585.451-103.149c260.741-313.339-247.542-178.872-627.09-295.944Z",
    opacity: 0.711
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M243.153-118.653C-57.032-222.85-152.198 96.81-162.259 269.665c31.823 460.118 367.884 286.622 433.098 11.985s354.535 179.56 588.694-82.655c271.517-304.048-241.149-187.402-616.38-317.648Z",
    opacity: 0.67
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M242.931-103.569c-296.366-114.61-402.63 201.534-418.717 373.932 15.745 460.949 357.657 299.287 432.415 27.093S604.682 489.28 847.85 235.397C1129.81-58.99 613.388 39.693 242.931-103.569Z",
    opacity: 0.629
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M242.183-88.502C-50.003-213.385-167.236 98.858-189.329 270.59c-.351 461.217 346.994 311.586 431.206 42.167 84.213-269.42 341.146 203.854 593.026-41.388C1126.97-12.999 607.414 67.601 242.183-88.502Z",
    opacity: 0.588
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M240.908-73.472C-46.742-208.476-174.8 99.486-202.874 270.342c-16.447 460.924 335.909 323.506 429.473 57.191 93.563-266.316 333.823 215.636 594.109-20.667C1122.52 32.865 600.469 95.283 240.908-73.472Z",
    opacity: 0.546
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M239.11-58.494C-43.652-203.454-182.381 99.851-216.4 269.623c-32.523 460.069 324.414 335.032 427.215 72.144s326.095 227.155 594.468.08c311.187-263.301-212.72-219.14-566.173-400.34Z",
    opacity: 0.505
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M236.792-43.587c-277.53-154.74-426.76 143.538-466.683 312.02-48.56 458.654 312.523 346.15 424.436 87.009C306.459 96.302 512.514 593.84 788.649 376.27 1108.84 123.988 583.706 149.839 236.792-43.587Z",
    opacity: 0.464
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M233.953-28.771C-38.008-193.103-197.557 99.785-243.336 266.77c-64.536 456.68 300.253 356.846 421.142 101.769 120.889-255.076 309.455 249.349 593.014 41.549 328.8-240.953-196.915-233.445-536.867-438.86Z",
    opacity: 0.422
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M230.601-14.063c-266.06-173.723-435.734 113.42-487.312 278.706-80.436 454.149 287.616 367.107 417.333 116.404 129.717-250.702 300.564 259.997 591.203 62.219C1088.83 213.935 563.176 203.091 230.601-14.063Z",
    opacity: 0.381
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M226.735.519C-33.101-182.384-212.691 98.662-270.007 262.047-366.243 713.113 4.623 638.969 143.01 392.946s291.307 270.328 588.671 82.814C1076.49 258.33 551.53 229.147 226.735.519Z",
    opacity: 0.34
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M222.364 14.957C-30.93-176.902-220.22 97.705-283.203 258.99-395.122 706.423-21.895 645.266 124.994 404.223s281.696 280.33 585.423 103.308C1062.6 302.267 538.982 254.781 222.364 14.957Z",
    opacity: 0.299
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M217.491 29.234C-28.953-171.348-227.71 96.485-296.284 255.475c-127.466 443.254 247.668 395.16 402.88 159.39s271.741 289.99 581.461 123.676c359.133-192.848-162.51-258.579-470.566-509.307Z",
    opacity: 0.258
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M212.125 43.333C-27.169-165.728-235.153 95.006-309.233 251.505-452.091 690.041-75.507 655.068 87.839 424.859c163.346-230.21 261.454 299.297 576.79 143.893 365.641-180.197-153.387-264.093-452.504-525.42Z",
    opacity: 0.216
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M206.267 57.235C-25.584-160.05-242.541 93.266-322.038 247.085-480.113 680.367-102.539 658.559 68.742 434.19c171.28-224.368 250.85 308.24 571.417 163.935 371.711-167.326-144.077-269.284-433.892-540.89Z",
    opacity: 0.175
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M199.929 70.924C-24.198-154.32-249.863 91.27-334.68 242.22c-173.1 427.502 205.005 418.884 384.012 200.63 179.006-218.255 239.94 316.806 565.348 183.777C992.004 472.376 480.089 352.479 199.929 70.924Z",
    opacity: 0.134
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M193.117 84.384c-216.13-232.929-450.228 4.636-540.261 152.535-187.915 421.2 190.261 425.783 376.776 213.909C216.146 238.954 258.369 775.815 588.22 654.224c382.478-140.99-124.941-278.679-395.104-569.84Z",
    opacity: 0.092
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M185.84 97.598c-207.87-240.33-450.116-11.08-545.256 133.587-202.5 414.386 175.286 432.164 369.08 226.928C203.46 252.878 226.922 790.885 560.817 680.88 947.981 553.324 445.676 398.01 185.84 97.598Z",
    opacity: 0.051
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M178.106 110.55C-21.249-136.888-271.35 83.768-371.48 225.026-588.319 632.092-211.383 663.044-10.544 464.697c200.84-198.347 205.51 340.151 543.041 241.866C923.878 592.597 427.3 419.847 178.106 110.55Z",
    opacity: 0.01
  })));
};
export default SvgPoviderSearchBackground;